import React from 'react'
import { useSearchParams } from 'react-router';
import scrollToTop from '../assets/scrollToTop';

const FinalStep = (props) => {
    const { steps } = props;
    const [searchParams, setSearchParams] = useSearchParams();

    const total = steps?.reduce((acc, step) => acc + ((Number(step.data?.price) * (step.data?.cantidad || 1)) || 0), 0) || 0;

    const irAlPaso = (step) => {
        searchParams.set('step', step.id);
        setSearchParams(searchParams, { replace: true });
        scrollToTop();
    }

    return (
        <div className='final-step'>
            <h2 className='final-title'>Tu PC armada</h2>
            <ul className='final-list'>
                { steps?.map(step => {
                    if(step.tag === 'final') return null;

                    if(!step.data) {
                        if(!step.required) return null;
 
                        return (
                            <li key={step.id} className='final-item final-item-missing' onClick={() => irAlPaso(step)}>
                                <div className='item-info'>
                                    <span className='item-tag'>{step.nombre}</span>
                                    <h3 className='item-name item-name-missing'>Este componente es requerido para terminar el armado</h3>
                                </div>
                                <span className='item-missing-cta'>Elegir →</span>
                            </li>
                        )
                    }

                    return (
                        <li key={step.id} className='final-item'>
                            <div className='item-img'>
                                <img src={step.data.image} alt={step.data.name} />
                            </div>
                            <div className='item-info'>
                                <span className='item-tag'>{step.nombre}</span>
                                <h3 className='item-name'>{step.data.name}</h3>
                            </div>
                            <span className='item-cantidad'>x{step.data.cantidad || 1}</span>
                            <span className='item-price'>${new Intl.NumberFormat("es-AR", {minimumFractionDigits: 2}).format(
                                (Number(step.data.price) * (step.data.cantidad || 1)).toFixed(2),
                            )}</span>
                        </li>
                    )
                }) }
            </ul>
            <div className='final-total'>
                <span>Total</span>
                <span className='final-total-price'>${new Intl.NumberFormat("es-AR", {minimumFractionDigits: 2}).format(total.toFixed(2))}</span>
            </div>
        </div>
    )
}

export default FinalStep;